import { FormControl, FormHelperText, FormLabel, Grid, TextField } from "@mui/material";
import { debounce } from "lodash";
import { FunctionComponent, useMemo, useState } from "react";

export interface ITimeIntervalPickerProps {
    value?: number | null;
    disabled?: boolean;
    required?: boolean;
    error?: boolean;
    label?: string;
    onChange: (value?: number | null) => void;
    errorText?: string;
};

export const TimeIntervalPicker: FunctionComponent<ITimeIntervalPickerProps> = (props) => {
    const { value, disabled, required, error, label, onChange, errorText } = props;
    const [minuteValue, setMinuteValue] = useState<number | null>(value ?? null);

    const debouncedHandleChange = useMemo(() => debounce((minutes: number | null) => {
        onChange(minutes);
    }, 300), [onChange]);

    return (
        <>
            <FormControl
                fullWidth
                disabled={disabled}
                required={required}
                error={error}>
                <Grid container direction='column'>
                    <Grid item>
                        <FormLabel>{label}</FormLabel>
                    </Grid>
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <TextField
                                label="Minutes"
                                type="number"
                                value={minuteValue ?? ''}
                                inputProps={{ min: 0, step: 1.0 }}
                                onChange={(e) => {
                                    let value = parseInt(e.target.value) as number | null;
                                    if (isNaN(value!)) {
                                        value = null;
                                    } else {
                                        if (value! < 0) {
                                            value = 0;
                                        }
                                    }
                                    setMinuteValue(value);
                                    debouncedHandleChange(value);
                                }}
                                fullWidth
                                disabled={disabled}
                                helperText="Enter total minutes (e.g., 120 for 2 hours)"
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <FormHelperText>{errorText}</FormHelperText>
            </FormControl>
        </>
    );
};
